import BaseCard from "../../Cards";
import styled from "styled-components";

export default styled(BaseCard)`
    height: 90vh;
    margin: 1.5em;
`;
